import React, {Component} from 'react';
import { Platform, View, Image, Text, FlatList, StyleSheet, TouchableOpacity } from 'react-native';
import Icon from "react-native-vector-icons/Ionicons";
import MediaConfig from '../../utils/chinesepark/MediaConfig';
import RoomClient from "../../utils/chinesepark/RoomClient";
import { Button, } from "native-base";
import _ from 'lodash';

class AudioIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            volume: 0,
        };

        this.onUserPublished = this.onUserPublished.bind(this);
        this.onUserUnpublished = this.onUserUnpublished.bind(this);
        this.onLocalPublished = this.onLocalPublished.bind(this);
        this.onLocalUnpublished = this.onLocalUnpublished.bind(this);
        this.onAudioVolume = this.onAudioVolume.bind(this);
    }

    componentDidMount() {
        if (this.props.engine) {
            this.initEngine(this.props.engine);
            this.updateMediaTracks();
        }

        MediaConfig.events.addListener("onAudioVolume", this.onAudioVolume);
        RoomClient.events.addListener("onLocalPublished", this.onLocalPublished);
        RoomClient.events.addListener("onLocalUnpublished", this.onLocalUnpublished);
        RoomClient.events.addListener("user-published", this.onUserPublished);
        RoomClient.events.addListener("user-unpublished", this.onUserUnpublished);
        if (!this._timer) {
            this._timer = setInterval(() => {
                let audioTrack = this.props.audioTrack;
                if (!audioTrack) {
                    audioTrack = this.audioTrack;
                }

                if (audioTrack) {
                    let v = audioTrack.getVolumeLevel();
                    v *= 100;
                    let r = parseInt(v);
                    if (r < 0) {
                        r = 0;
                    }
                    else if (r > 100) {
                        r = 100;
                    }
                    this.setState({volume: r});
                }
            }, 200);
        }
    }

    componentWillUnmount() {
        MediaConfig.events.removeListener("onAudioVolume", this.onAudioVolume);
        if (this._timer) {
            clearInterval(this._timer);
            delete this._timer;
        }

        RoomClient.events.removeListener("onLocalPublished", this.onLocalPublished);
        RoomClient.events.removeListener("onLocalUnpublished", this.onLocalUnpublished);
        RoomClient.events.removeListener("user-published", this.onUserPublished);
        RoomClient.events.removeListener("user-unpublished", this.onUserUnpublished);
        this.uninitEngine();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.engine !== this.props.engine) {
            this.uninitEngine();
            if (this.props.engine) {
                this.initEngine(this.props.engine);
            }
            this.updateMediaTracks();
        }
        else if (prevProps.uid !== this.props.uid) {
            this.updateMediaTracks();
        }
    }

    initEngine(engine) {
        this._engine = engine;
    }

    uninitEngine() {
        if (!this._engine) {
            return;
        }

        delete this._engine;
    }

    onUserPublished(user, mediaType) {
        if (user.uid === this.props.uid) {
            this.updateMediaTracks();
        }
    }

    onUserUnpublished(user, mediaType) {
        if (user.uid === this.props.uid) {
            this.updateMediaTracks();
        }
    }

    onLocalPublished() {
        if (!this.props.uid) {
            this.updateMediaTracks();
        }
    }

    onLocalUnpublished() {
        if (!this.props.uid) {
            this.updateMediaTracks();
        }
    }

    updateMediaTracks() {
        if (this.props.audioTrack) {
            this.audioTrack = null;
            return;
        }

        if (!this._engine) {
            this.audioTrack = null;
            return;
        }

        if (!this.props.uid) {
            this.audioTrack = this._engine._localAudioTrack;
            return;
        }

        var remoteUser = this._engine.remoteUsers.find(user => user.uid === this.props.uid);
        if (remoteUser) {
            this.audioTrack = remoteUser.audioTrack;
        }
        else {
            this.audioTrack = null;
        }
    }

    onAudioVolume(speakers) {
        for (var i = 0; i < speakers.length; ++i) {
            if (speakers[i].uid === this.props.uid) {
                var v = parseInt(100 * speakers[i].volume / 255);
                if (v < 0) {
                    v = 0;
                }
                else if (v > 100) {
                    v = 100;
                }
                this.setState({volume: v});
                break;
            }
        }
    }

    renderVolume() {
        if (this.props.disabled)
            return null;

        if (this.props.bigIcon) {
            if (this.props.onPress) {
                return (<View style={{zIndex: 2, position: 'absolute', backgroundColor: '#70fd66',
                                      borderRadius: 12, overflow: 'hidden',
                                      left: '35%', top: '8%', right: '35%', bottom: '42%'}}>
                            <TouchableOpacity style={{width: '100%', height: '100%'}} onPress={this.props.onPress}>
                                <View style={{width: '100%', height: (100 - this.state.volume) + '%',
                                              backgroundColor: '#fff'}}/>
                            </TouchableOpacity>
                        </View>);
            }
            return (<View style={{zIndex: 2, position: 'absolute', backgroundColor: '#70fd66',
                                  borderRadius: 12, overflow: 'hidden',
                                  left: '35%', top: '8%', right: '35%', bottom: '42%'}}>
                        <View style={{width: '100%', height: (100 - this.state.volume) + '%',
                                      backgroundColor: '#fff'}}/>
                    </View>);
        }

        if (this.props.onPress) {
            return (<View style={{zIndex: 2, position: 'absolute', backgroundColor: '#70fd66',
                                  borderRadius: 6, overflow: 'hidden',
                                  left: '40%', top: '24%', right: '40%', bottom: '40%'}}>
                    <TouchableOpacity style={{width: '100%', height: '100%'}} onPress={this.props.onPress}>
                    <View style={{width: '100%', height: (100 - this.state.volume) + '%',
                                  backgroundColor: '#fff'}}/>
                    </TouchableOpacity>
                    </View>);
        }
        return (<View style={{zIndex: 2, position: 'absolute', backgroundColor: '#70fd66',
                              borderRadius: 6, overflow: 'hidden',
                              left: '40%', top: '24%', right: '40%', bottom: '40%'}}>
                <View style={{width: '100%', height: (100 - this.state.volume) + '%',
                              backgroundColor: '#fff'}}/>
                </View>);
    }

    render() {
        if (this.props.bigIcon) {
            return (<View style={this.props.style}>
                        {this.props.onPress ?
                         (<TouchableOpacity style={{width: '100%', height: '100%'}}
                                            onPress={this.props.onPress}>
                              <Image style={{width: '100%', height: '100%'}}
                                     resizeMode='contain'
                                     source={this.props.disabled ?
                                             require('../../images/chinesepark/test.png') :
                                             require('../../images/chinesepark/test.png')}/>
                          </TouchableOpacity>) :
                         (<Image style={{width: '100%', height: '100%'}}
                                 resizeMode='contain'
                                 source={this.props.disabled ?
                                         require('../../images/chinesepark/test.png') :
                                         require('../../images/chinesepark/test.png')}/>)}
                        {this.renderVolume()}
                    </View>);
        }
        return (<View style={this.props.style}>
                {this.props.onPress ?
                 (<TouchableOpacity style={{width: '100%', height: '100%'}}
                                    onPress={this.props.onPress}>
                      <Image style={{width: '100%', height: '100%'}}
                             source={this.props.disabled ?
                                     require('../../images/audio_disable.png') :
                                     require('../../images/audio_enable.png')}/>
                  </TouchableOpacity>) :
                 (<Image style={{width: '100%', height: '100%'}}
                  source={this.props.disabled ?
                          require('../../images/audio_disable.png') :
                          require('../../images/audio_enable.png')}/>)}
                {this.renderVolume()}
                </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});

export default AudioIcon;
